import React from 'react';
import './email_confirmation_component.scss';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { resetPasswordOtp } from '../../../../gateway/api';
import validate from "validate.js";
import { emailConstraints } from '../../../../util/validation_constraints';
import { showCloseButtonClass, errorClass, clearInputContent } from '../../../../util/form_login_utils';
import ErrorMessageComponent from '../get_error_message';

const EmailConfirmationComponent = ({loginObj, handleChange, onButtonClick, errors, clearInput}) => {
  return(
    <div className="signin-component">
      {inputField(loginObj, handleChange, errors, clearInput)}
      <div className="buttons-container">
        {showButtonComponent({'name': 'Send OTP'}, onButtonClick, loginObj)}
        {showButtonComponent({'name': 'Back'}, onButtonClick, loginObj)}
      </div>
    </div>
  )
}

const inputField = (loginObj={}, handleChange, errors, clearInput) => {
  const signinFields = ["email"]
  return signinFields.map((signinField, index) => {
    return (
      <div key={index} className="input-field-container" id="input-field-container">
       <div className="email-confirmation-text">
        Please enter/modify the email address and we will send you an OTP to reset your password.
       </div>
       <label htmlFor="textInput" className="input-label">{signinField}</label>
         <div className="field">
          <input type={signinField}
                 className={`input-field-box ${errorClass(errors, signinField)} ${signinField}`}
                 value={loginObj[signinField]}
                 name={signinField}
                 onChange={(e) => handleChange(e, loginObj, errors)}></input>
          <span className={`input-close-button ${showCloseButtonClass(loginObj[signinField])}`}
                onClick={(e) => clearInput(e, signinField, loginObj, errors)}></span>
        </div>
        <ErrorMessageComponent inputField={signinField}/>
      </div>
    )
  })
}

const showButtonComponent = (opts, onButtonClick, loginObj) => {
  return(
    <div className={`metype-button-container`}>
      <button type="submit" className="metype-button"  onClick={(e) => onButtonClick(e, loginObj, opts)}>
        {opts.name}
      </button>
    </div>
  )
}

const mapStateToProps = ({formLoginReducers}) => {
  return {
    loginObj: formLoginReducers.loginObj,
    errors: formLoginReducers.errors
  }
}

const mapDispatchToProps = (dispatch, props) => {
  return {
    clearInput: (e, signinFieldLabel, loginObj, errors) => {
      clearInputContent(e, signinFieldLabel, loginObj, errors, dispatch);
    },
    handleChange: (e, loginObj, errors) => {
      dispatch({ type: 'LOGIN',...loginObj,[e.target.name]: e.target.value });
      if(e.target.value.length === 0 && ((errors[e.target.name] && errors[e.target.name].length > 0))) {
        dispatch({ type: 'ERRORS', ...errors, [e.target.name]: ""});
      }
    },
    onButtonClick: (e, loginObj, opts) => {
      e.preventDefault();
      e.stopPropagation();
      switch(opts.name) {
        case 'Back':
          dispatch({type: 'SCREEN', screen: 'signin'});
          dispatch({type: 'ERRORS', errors: ""});
          break;
        case 'Send OTP':
          const validateResponse = validate(loginObj, emailConstraints(), {fullMessages: false}) || {};
          dispatch({type: 'ERRORS', ...validateResponse});

          if (Object.keys(validateResponse).length === 0) {
            resetPasswordOtp( { email: loginObj.email })
            .then((response) => {
              dispatch({ type: 'SCREEN', screen: 'confirmOtp', passwordReset: true, source: "emailConfirmation"});
            })
            .catch(err => {
              const responseBody = err.res.body.error;
              const errCode = err.res.statusCode;
              if(errCode === 401) {
                dispatch({ type: 'ERRORS', email: [responseBody]})
              }
            });
          }
        }
    }
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(EmailConfirmationComponent);



// WEBPACK FOOTER //
// ./app/javascript/pages/page/form_login_modal/email_confirmation_component/email_confirmation_component.js